import {Directive, HostListener, Output, EventEmitter} from "@angular/core";

@Directive({
	 selector: '[prevent-enter]'
})

export class PreventEnter {
	@Output() submit: EventEmitter<any> = new EventEmitter();

	 @HostListener('keydown', ['$event'])
	 public onKeyDown(event: KeyboardEvent) {
			if(event.keyCode === 13){
			event.preventDefault();
				this.submit.next(true);
		}
	 }
}
